<div class="tab-pane" role="tabpanel" id="tipoperm">
    <fieldset id="agregar_tipoaperm" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <div class="form-horizontal titulo">
                            <div class="form-group" align="left">
                                <div class="col-md-2">
                                    <label for="tipoaprob">Tipo de Solicitud:</label>
                                </div>
                                <div class="col-md-10" class="inline">
                                    <div class="col-md-2" style="font-size: 13px">
                                        <mat-checkbox (change)="add_tipo_permiso()" formControlName="obra" name="obra" value="SI">OBRA NUEVA</mat-checkbox>
                                    </div>
                                    <div class="col-md-4" style="padding-bottom: 20px">
                                        <label for="loteo_dfl">Loteo DFL 2 con construccion Simultanea</label>
                                    </div>
                                    <div class="col-md-4">
                                        <mat-radio-group formControlName="loteo_dfl" (change)="add_tipo_permiso()">
                                            <mat-radio-button style="padding-right: 20px" name="loteo_dfl" value="SI">SI</mat-radio-button>
                                            <mat-radio-button style="padding-right: 20px" name="loteo_dfl" value="NO">NO</mat-radio-button>

                                        </mat-radio-group>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" align="left">
                                <div class="col-md-2"></div>
                                <div class="col-md-10" class="inline">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-4" style="padding-bottom: 20px">
                                        <label for="loteo_const">Loteo con Construccion Simultanea</label>
                                    </div>
                                    <div class="col-md-4">
                                        <mat-radio-group formControlName="loteo_const" (change)="add_tipo_permiso()">
                                            <mat-radio-button style="padding-right: 20px" name="loteo_const" value="SI">SI</mat-radio-button>
                                            <mat-radio-button style="padding-right: 20px" name="loteo_const" value="NO">NO</mat-radio-button>

                                        </mat-radio-group>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div class="form-group" align="left" style="padding-bottom: 20px; font-size: 13px">
                                <div class="col-sm-2"></div>

                                <div class="col-sm-10" class="inline">
                                    <div class="col-md-3">
                                        <mat-checkbox (change)="add_tipo_permiso()" formControlName="ampliacion" name="ampliacion" value="SI">AMPLIACION MAYOR A 100 M2</mat-checkbox>
                                    </div>
                                    <div class="col-md-2">
                                        <mat-checkbox (change)="add_tipo_permiso()" formControlName="alteracion" name="alteracion" value="SI">ALTERACION</mat-checkbox>
                                    </div>
                                    <div class="col-md-2">
                                        <mat-checkbox (change)="add_tipo_permiso()" formControlName="reparacion" name="reparacion" value="SI">REPARACION</mat-checkbox>
                                    </div>
                                    <div class="col-md-2" align="left">
                                        <mat-checkbox (change)="add_tipo_permiso()" formControlName="reconstruccion" name="reconstruccion" value="SI">RECONSTRUCCION</mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <br />
            </div>
        </div>

    </fieldset>
</div>
<div class="separator"></div>